/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AbsenceOwner } from '@absences/store/absence-owner';
import { Absence, AbsenceClass } from '@shared/models';

export interface AbsencesState {
  isActionPending: boolean;
  absences: Absence[];
  currentAbsence?: Absence;
  /** Fahrer oder Fahrzeug, dessen Abwesenheiten gerade angezeigt werden. */
  owner?: AbsenceOwner;
  absenceClasses: AbsenceClass[];
  /** Nur die Gruende des gerade angezeigten Ziels. */
  selectableAbsenceClasses: AbsenceClass[];
}

export const initialState: AbsencesState = {
  isActionPending: false,
  absences: [],
  absenceClasses: [],
  selectableAbsenceClasses: []
};
